/**
 * Created by guga on 8/4/2016.
 */

import { Response }                         from '@angular/http';
import { IRequestPayload}                   from './request-payload';
import { IXhrRequestPayload, IXhrResponse } from './xhr-types';
import { Observable }                       from 'rxjs/Observable';

export interface IRequestErrorHandler {
    (error : Response, requestPayload : IRequestPayload) : Observable<any>
}

export interface IXhrErrorHandler {
    (error : IXhrResponse, xhrRequestPayload : IXhrRequestPayload) : Observable<any>
}


// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/sas-models/error-handler.ts